import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

class Token {
  readonly accessToken: string;

  constructor(authToken: string) {
    this.accessToken = authToken;
  }
}

@Injectable()
export class AuthTokenStore {
  save(token: Token) {
    if (token == null) {
      localStorage.removeItem('AUTH_TOKEN');
    } else {
      localStorage.setItem('AUTH_TOKEN', token.accessToken);
    }
  }

  get(): Token {
    const accessToken = localStorage.getItem('AUTH_TOKEN');
    if (accessToken != null) {
      return new Token(accessToken);
    }
    return null;
  }
}

interface TokenResponse {
  token: string;
}


@Injectable()
export class AuthService {
  private http: HttpClient;
  private tokenStore: AuthTokenStore;

  constructor(http: HttpClient, tokenStore: AuthTokenStore, private router: Router) {
    this.http = http;
    this.tokenStore = tokenStore;
  }

  getAuthToken(): Token {
    return this.tokenStore.get();
  }

  login(username: string, password: string): Observable<Token> {
    return this.http
      .post('/auth/login', {
        'username': username,
        'password': password
      })
      .map(r => <TokenResponse>r)
      .map(r => new Token(r.token))
      .do(token => this.tokenStore.save(token));
  }

  requestPasswordReset(email: string): Observable<any> {
    return this.http.post('/auth/password/reset', {
      'email': email,
    })
  }

  setPassword(uid: string, token: string, password: string): Observable<any> {
    return this.http.post('/auth/password/reset/confirm', {
      'uid': uid,
      'token': token,
      'password': password,
    })
  }

  logout() {
    this.tokenStore.save(null);
    this.router.navigateByUrl('/login');
  }

  isLoggedIn() {
    return this.getAuthToken() != null;
  }
}

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) {
      return true;
    }

    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/services/auth.service.ts